module.exports = require('../../es/promise');
